<template>
    <div class="section section-numbers">
        <div class="section__inner">
            <div class="section__body">
                <div class="container">
                    <div class="row nowrap">
                        <NumbersCard v-for="(item, i) in items" :key="i" v-bind="item"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import NumbersCard from '../cards/NumbersCard.vue'

export default {
    name: 'NumbersSection',
    components: {
        NumbersCard,
    },
    props: {
        items: {
            type: Array,
            default: [],
        }
    },
    setup: (props, ctx) => {
        
        return {

        }
    },
}
</script>

<style lang="scss">
    .section-numbers {
        @include mobile {
            .row {
                flex-wrap: wrap;
            }
            .numbers__card {
                flex: initial;
                margin-top: 10px;
                &:first-child {
                    margin-top: 0;
                    width: 100%;
                }
            }
        }
    }
</style>